const packages = [
  {
    tag: "按需购买",
    tagColor: "bg-secondary-100 text-secondary-700",
    name: "收汇结汇服务",
    price: "按货值计费",
    priceSize: "text-[24px] md:text-[30px]",
    items: ["阳光收汇", "结汇到账", "留痕归档", "即买即用", "无使用期限"],
    cta: "立即购买",
  },
  {
    tag: "按需购买",
    tagColor: "bg-secondary-100 text-secondary-700",
    name: "全套餐次数包",
    price: "咨询定价",
    priceSize: "text-[24px] md:text-[30px]",
    items: ["含报关回执回传", "不含专家审阅", "不含值守服务", "灵活购买次数", "有效期内使用"],
    cta: "立即购买",
  },
];

export default function Experience() {
  return (
    <section id="experience" className="py-16 md:py-24 bg-gradient-to-b from-background-100 to-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-[24px] md:text-[32px] font-bold text-foreground-900 mb-3 tracking-tight">
            按需购买，灵活补充服务能力
          </h2>
          <p className="text-foreground-500 text-[14px] md:text-[15px]">
            无需绑定套餐，按实际货值或次数灵活选购，即买即用
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-[820px] mx-auto">
          {packages.map((p, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-3xl border-2 border-background-200 hover:border-primary-300 shadow-[0_8px_30px_-4px_rgba(0,0,0,0.04)] hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col h-full p-6 md:p-8"
            >
              <div className="mb-5">
                <span
                  className={`inline-block px-3.5 py-1 rounded-full text-[13px] font-medium ${p.tagColor}`}
                >
                  {p.tag}
                </span>
              </div>
              <h3 className="text-[17px] md:text-[18px] font-bold text-foreground-900 mb-4">
                {p.name}
              </h3>
              <div className="mb-6 md:mb-8">
                <span
                  className={`${p.priceSize} font-bold text-accent-600 leading-none tracking-tight`}
                >
                  {p.price}
                </span>
              </div>

              <ul className="space-y-3.5 mb-8 md:mb-10 flex-grow">
                {p.items.map((item, ii) => (
                  <li
                    key={ii}
                    className="text-[13px] md:text-[14px] text-foreground-600 flex items-center gap-2.5"
                  >
                    <i className="ri-check-line text-primary-500" />
                    {item}
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                className="w-full h-12 bg-accent-500 text-background-50 text-[15px] font-medium rounded-full hover:bg-accent-600 hover:shadow-lg hover:shadow-accent-500/20 transition-all duration-300 whitespace-nowrap flex items-center justify-center mt-auto"
              >
                {p.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}